module.exports = __webpack_public_path__ + "img/tutorial-grid1.3c75f545.png";